module.exports = __webpack_public_path__ + "static/plan-action-ffa9cb991bc524294ee3406197686c32.svg";